import { render, staticRenderFns } from "./_base-address-edit-modal.vue?vue&type=template&id=46fb640e&scoped=true"
import script from "./_base-address-edit-modal.vue?vue&type=script&lang=js"
export * from "./_base-address-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./_base-address-edit-modal.vue?vue&type=style&index=0&id=46fb640e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb640e",
  null
  
)

export default component.exports